<template>

  <div :class="generatorMainSectionClass">
    <div >


      <div v-if="showAddButton" class="drugstore-stage-action-buttons">
        <div
            class="d-none d-sm-inline-block btn btn-sm btn-success shadow-sm"
            @click="openAddForm()"
        >
          <i class="fas fa-plus-circle"/>
          Utwórz nową aptekę
        </div>

        <div class="d-none d-sm-inline-block btn btn-sm btn-success shadow-sm" @click="openImportModal"
             style="margin-left: 4px;">
          <i class="fas fa-file-excel "/>
          Importuj listę aptek
        </div>
        <div
            v-if="!commonModule.centralInstance"
            class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm"
            @click="openImportDrugstoresForm()"
            style="margin-left: 4px;"
        >
          <i class="fas fa-download"/>
          Importuj dane aptek z centrali
        </div>

        <div
            v-if="commonModule.centralInstance"
            class="d-none d-sm-inline-block btn btn-sm btn-success shadow-sm"
            @click="openCreateDrugstoresSourceForm()"
            style="margin-left: 4px;"
        >
          <i class="fas fa-download"/>
          Utwórz apteki z danych źródłowych
        </div>

        <div
            class="d-none d-sm-inline-block btn btn-sm btn-info shadow-sm"
            @click="exportDrugstoresDataToFile()"
            style="margin-left: 4px;"
        >
          <i class="fas fa-file-export"/>
          Eksportuj dane aptek do pliku
        </div>


      </div>


      <div class="row">
        <SearchBar2
            :searchOptions="fieldsAvailableForSearch"
            @searchRequest="searchOnList($event)"
        />
      </div>


      <div class="row">
        <div>
          <CommonTable2
              :table="tableData"
              :key="refreshTable"
              rowIdentifier="drugstoreClientId"
              @onItemAction="handleItemAction($event)"
              @onSort="sortBy($event)"
              @onMassAction="handleMassAction($event)"
              @onCheckItem="handleCheckItem($event)"
              @onSelectRow="selectRow($event)"
              :currentPage="currentPage"
              :totalRows="commonModule.getDrugstoresDataTotal"
              :totalPages="commonModule.getDrugstoresPagesCount"
              :showPaginationTop="true"
              :showPaginationBottom="true"
              @onPageChange="currentPage = $event"
              :sortColumn="sortColumn"
              :sortDirection="sortingDirection"
              :showMassActions="showMassActions"
              :showRowActions="showRowActions"
              :multiselect="multiselect"
              :initiallyCheckedItemsData="selectedDrugstoresData"
              :disableInitiallyCheckedItems="disableInitiallyCheckedItems"
              :ignoreInitiallyCheckedItems="ignoreInitiallyCheckedItems"
              :initiallyVisibleColumns="visibleColumnsFilter"
              :enableRowSelection="enableRowSelection"
              :showCheckboxColumn="showCheckboxColumn"
              :stickyScrollbarBottom="0"
          />

        </div>


        <div class="p-4">
        </div>


        <slot name="bottom"></slot>
      </div>
    </div>
  </div>
  <div>

    <b-modal
        style="z-index: 999999!important;"
        v-model="drugstoreFormDisplayed"
        id="add-drugstore-form-modal"
        scrollable
        :title="drugstoreFormTitle"
        title-class="font-18"
        hide-footer
        size="xl"
    >
      <DrugstoreForm2
          v-if="drugstoreFormDisplayed"
          :editedDrugstore="currentEditedDrugtore"
          @onSave="onDrugstoreSaved"
          @onCloseForm="closeForm()"
      />

    </b-modal>



    <b-modal
        v-model="importDrugstoresFormDisplayed"
        id="import-drugstore-form-modal"
        scrollable
        title="Importuj apteki z centrali"
        title-class="font-18 fw-bold"
        hide-footer
        size="xl"
    >
      <div class="mb-3">
        <div class="alert alert-warning d-flex align-items-center mb-0">
          <i class="fas fa-exclamation-triangle me-3 fs-4"></i>
          <div>
            Import danych o aptekach spowoduje <b>nadpisanie</b> lokalnie zgromadzonych danych,
            za wyjątkiem danych lokalnej apteki.
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-end align-items-center gap-2 mt-4 pt-3 border-top">

        <button
            class="btn btn-outline-secondary px-4 me-auto"
            @click="closeImportDrugstoresForm()"
        >
          Anuluj
        </button>

        <button
            class="btn btn-primary px-3"
            @click="importDrugstoresFromApi()"
        >
          <i class="fas fa-cloud-download-alt me-2"></i> Importuj z API
        </button>

        <button
            class="btn btn-primary px-3"
            @click="importDrugstoresFromFtp()"
        >
          <i class="fas fa-server me-2"></i> Importuj z serwera FTP
        </button>
      </div>

    </b-modal>


    <b-modal
        v-model="createDrugstoresSourceDataFormDisplayed"
        id="import-drugstores-from-source-data-form-modal"
        scrollable
        title="Utwórz apteki z danych źródłowych"
        title-class="font-18 fw-bold"
        hide-footer
        size="xl"
    >
      <div class="mb-3">
        <p class="mb-1">
          Proces utworzy/zaktualizuje apteki na podstawie danych źródłowych pobieranych z aptek.
        </p>
        <p class="mb-0 text-muted">
          <i class="fas fa-info-circle me-1"></i>
          <b>Uwaga: Zostaną nadpisane dane aptek będących w bazie</b> . Mapowanie odbywa się po numerze ID Kamsoft.
        </p>
      </div>

      <div class="d-flex justify-content-end align-items-center gap-2 mt-4 pt-3 border-top">
        <button
            class="btn btn-outline-secondary px-4"
            @click="closeCreateDrugstoresSourceForm()"
        >
          Anuluj
        </button>

        <button
            class="btn btn-primary px-4"
            @click="createDrugstoresBaseOnSourceData()"
        >
          <i class="fas fa-file-import me-1"></i> Utwórz apteki
        </button>
      </div>

    </b-modal>
    <DrugstoresListImportWrapper
        ref="drugstoresImport"
        @refresh-list="refreshDrugstoresList"
    />

  </div>

</template>

<script>
import Swal from "sweetalert2";
import SearchBar2 from "@/components/widgets/SearchBar2.vue";
import DrugstoreForm2 from "./DrugstoreForm2.vue";
import {log} from "@/state/pinia/log";
import {BModal} from "bootstrap-vue-next";
import {useSimplepharmAuthModule} from "@/state/pinia/simplepharmAuthModule";
import {mapStores} from "pinia";
import {useCommonAppModule} from "@/state/pinia/commonAppModule";
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";

import CommonTable2 from "@/components/widgets/CommonTable2.vue";
import {useLayoutStore} from "@/state/pinia";
import DrugstoresListImportWrapper from "@/views/DrugstoreCommonManager/DrugstoresListImportWrapper.vue";



export default {
  name: "DrugstoresList",
  components: {DrugstoresListImportWrapper, CommonTable2, DrugstoreForm2, SearchBar2, BModal},
  props: {
    multiselect: {
      type: Boolean,
      default: true,
    },
    showMassActions: {
      type: Boolean,
      default: () => true
    },
    showRowActions: {
      type: Boolean,
      default: () => true
    },
    showAddButton: {
      type: Boolean,
      default: () => true
    },
    selectedDrugstoresData: {
      type: Array,
      default: () => []
    },
    disableInitiallyCheckedItems: {type: Boolean, default: () => false},
    ignoreInitiallyCheckedItems: {type: Boolean, default: () => false},
    visibleColumnsFilter:{ // declare only columns keys You want to see
      type:Array,
      default: ()=>[]
    },
    enableRowSelection: {
      type: Boolean,
      default: () => true
    },
    showCheckboxColumn: {
      type: Boolean,
      default: () => true
    },
    displayInBootstrapRow: {
      type: Boolean,
      default: () => false
    },
  },
  emits: ["onSelect","onSelectRow"],
  data() {
    return {
      selectedIds: [],
      localDrugstores: [],
      buttonsEnabled: true,
      selectedItems: [],
      selectAllItems: false,
      itemsMassActionsEnabled: false,
      refreshTable: true,
      sortingDirection: "ASC",
      currentPage: 1,
      searchAndFilterRequest: {
        searchPhrase: "",
        searchKey: "name",
      },

      sortColumn: "drugstoreClientId",
      tableData: {},

      tableMassActions: [
        {
          action: "delete-drugstores",
          text: "Usuń apteki",
          icon: "fas fa-trash-alt",
          class: "btn btn-danger mass-operations-btn",
          enabled: true,
        },
      ],
      availableHeaders: [
        {key: "drugstoreClientId", text: "Numer", type: "text", sortable: true, width: "160px"},
        {key: "name", text: "Nazwa", type: "text", sortable: true, width: "360px"},
        {key: "address", text: "Adres", type: "text", sortable: false, width: "160px"},
        {key: "nip", text: "NIP", type: "text", sortable: false, width: "160px"},
        {key: "actions", text: "Akcje", type: "actions", sortable: false,width: "100px"}
      ],
      drugstoreFormDisplayed: false,
      importDrugstoresFormDisplayed: false,
      createDrugstoresSourceDataFormDisplayed: false,
      currentEditedDrugtore: {},
      drugstoreFormTitle: "Formularz dodawania apteki",
      fieldsAvailableForSearch:[],


    };
  },
  computed: {
    simplepharmAuth() {
      return useSimplepharmAuthModule();
    },
    commonModule() {
      return useCommonAppModule();
    },
    lazyloaderModule() {
      return useLazyLoaderModule();
    },
    layoutStore() {
      return useLayoutStore();
    },
    layout: {
      get() {
        return this.layoutStore.layoutType;
      },
      set(layout) {
        this.layoutStore.changeLayoutType(layout);
      }
    },
    generatorTableSectionClass() {
      if (this.layout === 'vertical' || this.displayInBootstrapRow) {
        return 'generator-table-container-vertical windows-like-breadcrumb-card shadow-sm scrollable-container';
      } else {
        return 'generator-table-container windows-like-breadcrumb-card shadow-sm scrollable-container';
      }
    },
    generatorMainSectionClass() {
      if (this.layout === 'vertical' || this.displayInBootstrapRow) {
        return 'row package-orders-generator-site';
      } else {
        return 'package-orders-generator-site';
      }
    },
  },
  methods: {
    openImportModal() {
      this.$refs.drugstoresImport.open();
    },
    refreshFieldsAvailableForSearch(){
      this.fieldsAvailableForSearch = [];
      var tableColumnsAvailableForSearch = this.availableHeaders.filter(header => this.commonModule.getDrugstoresAvailableSearchOptions.includes(header.key) && header.type === "text");
      for(var i=0; i<tableColumnsAvailableForSearch.length; i++){
        this.fieldsAvailableForSearch.push({
          name: tableColumnsAvailableForSearch[i].text,
          key: tableColumnsAvailableForSearch[i].key
        });
      }
    },
    handleSelection(payload) {
      this.selectedIds = payload.items;
      console.log("Wybrano:", payload);
    },
    handleDataStateChange(state) {
      console.log("Kompletny stan grida do wysłania do API:", state);
      // Np: { action: 'sort', sortColumn: 'name', sortDirection: 'Ascending' }
    },
    handleChartChange(chartData) {
      console.log("Dane wykresu zmienione:", chartData);
      // Np: { chartType: 'Pie', data: [...] }
    },
    handleDataFilter(filterData) {
      console.log("Dane filtra zastosowane:", filterData);
      // Np: { column: 'name', filterValue: 'Apteka 1' }
    },

    toggleSortingDirection() {
      if (this.sortingDirection === "ASC") {
        this.sortingDirection = "DESC";
      } else {
        this.sortingDirection = "ASC";
      }
    },
    sortBy(sortingKeyValue) {
      this.toggleSortingDirection();
      console.log("Sortowanie po:", sortingKeyValue);
      this.sortColumn = sortingKeyValue
      this.currentPage = 1;
      this.refreshDrugstoresList();
    },

    onDrugstoreSaved(){
      this.refreshDrugstoresList();
    },

    handleMassAction(event) {
      if (event.action.action === "delete-drugstores") {
        this.removeDrugstores(null, true);
      }
    },
    openAddForm() {
      this.drugstoreFormTitle = "Formularz dodawania apteki";
      this.currentEditedDrugtore = this.getEmptyDrugstoreObject();
      this.drugstoreFormDisplayed = true;
    },

    getEmptyDrugstoreObject() {
      return {
        id: null,
        drugstoreClientId: "",
        name: "",
        address: "",
        zipcode: "",
        city: "",
        nip: "",
        phoneNumber: "",
        email: "",
        apiBaseUrl: "",
        apiLogin: "",
        apiPassword: "",
        dbServer: "",
        dbUser: "",
        dbPassword: "",
        dbName: "",
        dbDriver: "FIREBIRD",
        inGroup: false,
        isCurrent: false,
        references: [],
      };
    },
    openEditForm(drugstore) {
      this.drugstoreFormTitle = "Formularz edycji apteki";

      log.log("Edited drugstore");
      log.log(drugstore);
      this.currentEditedDrugtore = drugstore;
      this.currentEditedDrugtore.references = drugstore.references;
      this.drugstoreFormDisplayed = true;
    },
    closeForm() {
      this.refreshDrugstoresList()
      this.drugstoreFormDisplayed = false;
      this.currentEditedDrugtore = {};
    },
    openImportDrugstoresForm() {
      this.importDrugstoresFormDisplayed = true;
    },
    closeImportDrugstoresForm() {
      this.importDrugstoresFormDisplayed = false;
    },
    openCreateDrugstoresSourceForm() {
      this.createDrugstoresSourceDataFormDisplayed = true;
    },
    closeCreateDrugstoresSourceForm() {
      this.createDrugstoresSourceDataFormDisplayed = false;
    },


    importDrugstoresFromApi() {
      this.refreshTable = false;
      this.commonModule.httpImportDrugstoresFromCentralRest().then(() => {
        this.importDrugstoresFormDisplayed = false;
        this.refreshTable = true; //refreshing Drugstores list component
      });
    },
    importDrugstoresFromFtp() {
      this.refreshTable = false;
      this.commonModule.httpImportDrugstoresFromCentralFtp().then(() => {
        this.importDrugstoresFormDisplayed = false;
        this.refreshTable = true; //refreshing Drugstores list component
      });
    },

    createDrugstoresBaseOnSourceData() {
      this.refreshTable = false;
      this.commonModule.httpUpdateDrugstoresBaseOnSourceData().then(() => {
        this.createDrugstoresSourceDataFormDisplayed = false;
        this.refreshTable = true; //refreshing Drugstores list component
        this.refreshDrugstoresList();
      });
    },





    exportDrugstoresDataToFile() {
      this.commonModule.httpExportDrugstoresToFile();
    },
    removeDrugstores(itemIdToRemove, removeAllChecked) {

      Swal.fire({
        title: "Czy na pewno chcesz usunąć te apteki?",
        text: "Proces usuwania jest nieodwracalny.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: "Nie",
        confirmButtonText: "Tak",
        customClass: {
          container: "swal-highest"
        }
      }).then((result) => {
        if (result.isConfirmed) {
          var itemsIdsToRemove = [itemIdToRemove];
          if (removeAllChecked === true) {
            itemsIdsToRemove = this.selectedItems.map(item => item.drugstoreClientId);
          }
          var requestPayload = {
            drugstoresIds: itemsIdsToRemove,
          };
          this.commonModule.httpRemoveDrugstores(requestPayload).then(() => {
            this.refreshDrugstoresList()
          });
        } else {
          // swal("Your imaginary file is safe!");
          // Do nothing...
        }
      });

    },

    handleItemAction(event) {
      console.log(event)
      const drugstoreId = event.itemData.drugstoreClientId;
      if (event.action.action === "edit-drugstore") {
        const drugstore = this.commonModule.getDrugstores.find(d => d.drugstoreClientId === drugstoreId);
        this.openEditForm(drugstore)
      } else if (event.action.action === "delete-drugstore") {
        this.removeDrugstores(drugstoreId, false);
      }
    },

    handleCheckItem(event) {
      log.log("Check item", event);
      this.selectedItems = event.itemsData;
      this.$emit("onSelect", event.itemsData);

    },

    selectRow(event) {
      log.log(event);
      this.$emit("onSelectRow", event);
    },

    refreshDrugstoresList() {
      this.commonModule.setDrugstores([]);
      var requestPayload = {
        currentPage: this.currentPage,
        sortingKey: this.sortColumn,
        sortingDirection: this.sortingDirection,
        searchAndFilterRequest: this.searchAndFilterRequest,
      };
      this.refreshTable = false
      this.commonModule.httpGetDrugstoresPaging(requestPayload).then(() => {
        this.localDrugstores = JSON.parse(JSON.stringify(this.commonModule.getDrugstores));
        var drugstoresRows = []

        for (var i = 0; i < this.localDrugstores.length; i++) {
          const drugstoreRow = {
            drugstoreClientId: this.localDrugstores[i].drugstoreClientId,
            name: this.localDrugstores[i].name,
            address: `${this.localDrugstores[i].address}, ${this.localDrugstores[i].zipcode} ${this.localDrugstores[i].city}`,
            actions: [
              {
                icon: "fas fa-edit",
                class: "btn btn-info table-actions-button edit-button",
                text: "",
                action: "edit-drugstore",
                enabled: this.buttonsEnabled
              },
              {
                icon: "fas fa-trash-alt",
                class: "btn btn-danger table-actions-button",
                text: "",
                action: "delete-drugstore",
                enabled: this.buttonsEnabled
              }
            ]
          };
          drugstoresRows.push(drugstoreRow);

        }


        this.tableData["headers"] = this.availableHeaders;
        this.tableData["massActions"] = this.tableMassActions;
        this.tableData["data"] = drugstoresRows;

        this.refreshTable = true;

      });
    },


    searchOnList(searchAndFilterRequestPayload) {
      this.searchAndFilterRequest = searchAndFilterRequestPayload;
      this.commonModule.setDrugstores([]);
      this.currentPage = 1;
      this.refreshDrugstoresList();
    },

  },

  watch: {
    currentPage: {
      handler() {
        this.refreshDrugstoresList();
      },
      deep: true,
    },
  },
  created() {
    this.simplepharmAuth.refreshToken().then(() => {
      this.commonModule.httpGetWorkingProfile().then(() => {
        console.log("Working profile loaded", this.commonModule.centralInstance)
        this.refreshFieldsAvailableForSearch();
        this.refreshDrugstoresList();
      })
    });




  },
};


</script>

<style scoped>
.table-actions {
  display: inline-block;
}

.table-actions-button {
  font-size: 0.8em !important;
  margin-left: 5px;
  margin-right: 5px;
}

.edit-button {
  color: #fff;
}

.drugstore-table {
  background: white;
}

.drugstore-row-selected {
  background: #7b9fe7;
}

.drugstore-stage-action-buttons {
  text-align: right;
  margin-right: 4px;
  margin-bottom: 16px;
  margin-top: 16px;
}

.package-orders-generator-site {

}




</style>
